import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TableRow',
  props: {
    class: {},
    style: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    "data-slot": "table-row",
    style: _normalizeStyle(props.style),
    class: _normalizeClass(
            _unref(cn)(
                'data-[state=selected]:[&_td]:bg-table-selected-row transition-colors [&_td]:inset-shadow-[0_-1px_0_0_var(--table-border)] last:[&_td]:inset-shadow-none',
                // 'hover:[&_td]:bg-faded',
                props.class,
            )
        )
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})